import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { UtilisateurDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-utilisateur',
  templateUrl: './utilisateur.component.html',
  styleUrls: ['./utilisateur.component.css']
})
export class UtilisateurComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.utilisateursEC$) utilisateurs$: Observable<UtilisateurDto[]>;

  private _utilisateurId: number = null;
  Utilisateurs: UtilisateurDto[] = [];

  @Input()
  get utilisateurId() {
    return this._utilisateurId;
  }
  set utilisateurId(val) {
    this._utilisateurId = val;
    this.getUtilisateurInComponent();
  }

  UtilisateurInComponent: string;

  u: Subscription;

  constructor() { }

  ngOnInit() {
    this.u = this.utilisateurs$.subscribe(res => {
      if (res != null) {
        this.Utilisateurs = res;
        this.getUtilisateurInComponent();
      }
    });
  }

  getUtilisateurInComponent() {
    let utilisateur = this.Utilisateurs.find(c => c.Id == this.utilisateurId);
    this.UtilisateurInComponent = (utilisateur) ? `${utilisateur.Prenom} ${utilisateur.Nom}` : null;
  }

  ngOnDestroy() {
    this.u?.unsubscribe();
  }
}
